<div class="tabular-mapping-container">

    <!-- ================= COLUMNS ================= -->
    <div class="columns-mapping-container">
        <ul>
            <li *ngFor="let col of displayColumns()">
                <span>{{ col.name }}</span>

                <span
                    style="color: var(--primary); font-weight: bold; text-transform: uppercase;"
                >
                    {{ getLabelByValue(col.type) }}
                </span>
            </li>
        </ul>
    </div>

    <!-- ================= PREVIEW ================= -->
    <div class="preview-tabular-container">

        <mat-progress-bar
            class="pending-list-progress-bar"
            mode="determinate"
            [value]="createRepositoryLoadingProgress | async"
            *ngIf="isFinishing"
        ></mat-progress-bar>

        <div class="errors-wrapper">

            <ng-container *ngIf="groupedErrors() as errors">

                <!-- ======== COM ERROS ======== -->
                <ng-container *ngIf="errors.length > 0; else noErrorsTemplate">

                    <ng-container *ngIf="!showDetailedErrors()">
                        <div style="position: absolute; top: 1rem; right: 1rem; z-index: 10;">
                            <button
                                class="secondary"
                                (click)="toggleDetailedErrors()"
                                style="padding: 6px 16px; background: #333; color: #fff; border: 1px solid #444; border-radius: 6px; cursor: pointer;"
                            >
                                Ver erros
                            </button>
                        </div>

                        <app-status-page
                            [mainTitle]="'Erros de Validação'"
                            [description]="'Foram encontrados erros de validação nos dados.\nEm caso de dúvidas, entre em contato com o nosso suporte através do email: <b>contato@forestoken.com.br</b>, ou clique em &quot;Ver erros&quot; para mais detalhes.'"
                            [variant]="'error'"
                            *ngIf="!isLoading()"
                        ></app-status-page>
                    </ng-container>

                    <ng-container *ngIf="showDetailedErrors()">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                            <h6 *ngIf="showErrorsSectionTitle()" style="margin: 0;">
                                As seguintes linhas apresentam erros:
                            </h6>
                            <button
                                class="secondary"
                                (click)="toggleDetailedErrors()"
                                style="padding: 6px 16px; background: #333; color: #fff; border: 1px solid #444; border-radius: 6px; cursor: pointer;"
                            >
                                Ocultar erros
                            </button>
                        </div>

                        <div class="validation-errors">

                            <div
                                class="error-group"
                            *ngFor="let error of errors; let i = index"
                            [class.invalid-file-group]="error.is_invalid_file"
                            [style.animationDelay.ms]="i * 80"
                        >

                            <!-- ERRO PADRÃO -->
                            <ng-container *ngIf="!error.is_invalid_file; else invalidFile">

                                <div class="error-group-header">
                                    <div class="error-title">
                                        <span class="error-column">
                                            Coluna "{{ error.column_name }}"
                                        </span>

                                        <span class="error-count">
                                            {{ error.rows.length }} linha(s) com erro nesta página
                                        </span>
                                    </div>

                                    <div class="error-type-badge">
                                        Selecionado: {{ error.expected_type }}
                                    </div>
                                </div>

                                <div class="error-description">
                                    Os valores abaixo não correspondem ao tipo selecionado.
                                </div>

                                <div class="error-rows">
                                    <div
                                        class="error-row-item"
                                        *ngFor="let row of error.rows; let idx = index"
                                    >
                                        <span class="row-number">
                                            Linha {{ row }}
                                        </span>

                                        <span class="row-value">
                                            {{ 
                                                error.values[idx] != ' ' ? 
                                                `"${error.values[idx]}"` : 
                                                'Valor é um espaço (\" \")'
                                            }}
                                        </span>
                                    </div>
                                </div>

                            </ng-container>

                            <!-- ERRO DE ARQUIVO INVÁLIDO -->
                            <ng-template #invalidFile>
                                <app-status-page
                                    [mainTitle]="'Muitos erros encontrados'"
                                    [description]="error?.error_message"
                                    [variant]="'error'"
                                    *ngIf="!isLoading()"
                                ></app-status-page>
                            </ng-template>

                        </div>

                    </div>

                    <mat-paginator
                        *ngIf="showErrorsSectionTitle()"
                        [length]="total()"
                        [pageSize]="pageSize()"
                        [pageSizeOptions]="pageSizesArray"
                        aria-label="Selecione a pagina"
                        [showFirstLastButtons]="true"
                        (page)="handlePageChange($event)"
                    >
                        </mat-paginator>
                    </ng-container>

                </ng-container>

            </ng-container>            <!-- ======== SEM ERROS ======== -->
            <ng-template #noErrorsTemplate>

                <app-status-page
                    [mainTitle]="'Nenhum erro encontrado'"
                    [description]="'Os dados são válidos e prontos para finalizar a importação.'"
                    [variant]="'success'"
                    *ngIf="!isLoading()"
                ></app-status-page>
            </ng-template>

        </div>

    </div>

    <!-- ================= BUTTONS ================= -->
    <div class="button-container">
        <button
            class="secondary"
            (click)="handleCancelClick()"
            [disabled]="isFinishing"
        >
            Descartar Importação
        </button>

        <button
            class="primary"
            (click)="handleButtonClick()"
            [disabled]="isFinishing || groupedErrors().length > 0"
            [innerText]="isFinishing ? 'Importando...' : 'Concluir Importação'"
        ></button>
    </div>

</div>

<app-alert
    title="Cancelar importação"
    message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
    confirmText="Confirmar"
    cancelText="Voltar"
    [visible]="isAlertVisible"
    (onConfirmEvent)="handleCancelClickConfirmation()"
    (onCancelEvent)="handleCancelClickCancel()"
></app-alert>